/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { userListConfig } from '../../config/userLists.config';
import { GET_USER_LIST } from '@pages/AdminPage/api/graphql';
import { useOrgId } from '../../provider';
import { vappContainer } from '@/application';
import { AppNavigatorService } from '@/AppNavigator/services';
import { apiConfig } from '@pages/AdminPage/config/api.config';
import { toHeaderCase } from 'js-convert-case';
import { StorageModule } from '@vlinder-web/storage-module-react';
import moment from 'moment';
import { Graphql } from '@common/graphql';
const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface IUserListPluginMethods extends IPluginMethodMap {
  getUserListSync(args: any): Promise<any>;
}

export class UserListPlugin implements IAgentPlugin {
  readonly methods: IUserListPluginMethods;

  constructor() {
    this.methods = {
      getUserListSync: this.getUserListSync.bind(this),
    };
  }

  async getUserListSync(args?: any) {
    await new Promise((r) => setTimeout(r, 2000));
    return await this.getAppCardList(args);
    // return {
    //   userList:userListConfig
    // };
  }

  private async getAppCardList(args: any) {
    const { orgId } = useOrgId();
    const storageSrv = StorageModule?.getInstance();
    const myOrgId = storageSrv?.get('myProfile', 'session')?.org?.orgId;
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      // const token = getToken();
      const token = loginSrv()?.getToken();
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      const res = await client
        .query(GET_USER_LIST, {
          input: {
            skip: args?.offset ?? 0,
            limit: args?.size ?? 10,
            where: [
              {
                column: 'org',
                value: [myOrgId],
                op: 'Equal',
              },
              ...args?.where,
            ],
          },
          roleInput: {
            offset: args?.offset ?? 0,
            size: args?.size ?? 10,
          },
        })
        .toPromise();
      if (res?.data) {
        console.log(`table data`, res);
        let _rowData = this.formatUserTable(res?.data?.getUserList?.data);
        console.log(`row data`, _rowData);
        return {
          ...userListConfig,
          ultUsers: _rowData,
          userRoles: res?.data?.getRoleList?.data,
          isEmpty: res?.data?.getUserList?.data?.length <= 0,
          // studentGroup: holderGroups,
          activePage: res?.data?.getUserList?.currentPage,
          pageSize: res?.data?.getUserList?.pageSize,
          totalCount: res?.data?.getUserList?.totalCount,
          totalPages: res?.data?.getUserList?.totalPages,
        };
      }
    } catch (err: any) {
      return {
        isEmpty: true,
      };
    }
  }
  private formatUserTable(data: any) {
    let _rowData: any =
      Array.isArray(data) &&
      data.map((item: any) => {
        return {
          id: item?.vuid,
          // status: item?.status,
          status: this.getFormattedStatus(item?.accountStatus, item?.suspended),
          name: `${toHeaderCase(item?.firstName ?? '')} ${toHeaderCase(
            item?.lastName ?? ''
          )}`,
          email: item?.email,
          dateCreated: this.formatCreatedDate(item?.createdAt),
          image: item?.image,
          verified: item?.emailVerified,
        };
      });

    return _rowData;
  }

  private formatCreatedDate(date: Date) {
    if (date) {
      return moment(date).format('LLL');
    }
  }

  private getFormattedStatus(status: string, suspended: boolean) {
    if (suspended) {
      return 'suspended';
    } else {
      switch (status) {
        case 'USER_ADDED':
          return 'created';
        case 'USER_INVITED':
          return 'invited';
        case 'USER_EMAIL_VERIFIED':
          return 'verified';
        case 'USER_VERIFIED':
          return 'verified';
        case 'USER_ACC_CREATED':
          return 'active';
        case 'WALLET_REGISTERED':
          return 'active';
        case 'SUSPENDED':
          return 'suspended';
        default:
          return '-';
      }
    }
  }
}
